import { render, staticRenderFns } from "./TreeChart.vue?vue&type=template&id=66536d01&"
import script from "./TreeChart.vue?vue&type=script&lang=js&"
export * from "./TreeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports